import LeadFormData from '../../LeadsComponents/LeadFormData';
import useLeadsStore from '../../../../store/LeadsStore'
import i18next from 'i18next';
import toaster from '../../../../utils/toaster'
import { LeadCreateRequestDTO } from '../../../../api/models/Leads/LeadCreateRequestDTO';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from '../../../../hooks/useApiClient';
import { ReactSelectOption } from '../../../../types';
import { useErrorToast } from '../../../../hooks/useErrorToast';
import { validationsLeadCreateForm } from '../../Validations/validationsLeadForm';
import '../../../../pages/Leads/LeadsPage.scss';

const LeadCreate = () => {
  const { activeLead } = useLeadsStore();
  const { apiClient } = useApiClient();
  const queryClient = useQueryClient();
  const { showError } = useErrorToast();

  const initialValues: LeadCreateRequestDTO = {
    Cliente__c: activeLead?.Cliente__c,
    Motivazione__c: activeLead?.Motivazione__c || "",
    FirstName: activeLead?.FirstName || "",
    LastName: activeLead?.LastName || "",
    Company: activeLead?.Company || "",
    Email: activeLead?.Email || "",
    Phone: activeLead?.Phone || "",
    City: activeLead?.City || "",
    Codice_Fiscale__c: activeLead?.Codice_Fiscale__c || "",
    Partita_Iva__c: activeLead?.Partita_Iva__c || "",
    Marca__c: activeLead?.Marca__c || "",
    Modello__c: activeLead?.Modello__c || "",
    LeadSource: activeLead?.LeadSource || null,
    Canale_del_lead__c: activeLead?.Canale_del_lead__c || null,
    Messaggio__c: activeLead?.Messaggio__c || "",
    Utm_sorgente__c: activeLead?.Utm_sorgente__c || "",
    Filiale_Dealer_Titolare__c: activeLead?.Filiale_Dealer_Titolare__c || "",
    LastModifiedDate: activeLead?.LastModifiedDate || "",
    SalesUser: null,
    Fonte_di_acquisizione__c: activeLead?.Fonte_di_acquisizione__c,
  };

  const createLeadMutation = useMutation({
    mutationFn: (payload: LeadCreateRequestDTO) => {
      return apiClient.leadsControllerService.createLead(payload);
    },
    onSuccess: (data) => {
      toaster.success(i18next.t('lead_created_successfully'));
      queryClient.invalidateQueries({ queryKey: ["leads_list"] });
    },
    onError: (error: any) => {
      console.error('Error creating lead: ', error);
      showError(error, i18next.t('error_user_not_found'));
    },
  });

  const { data: fields } = useQuery({
    queryKey: ['lead_source_fields'],
    queryFn: async (): Promise<{
      leadSourceOptions: ReactSelectOption[];
      fonteAcquisizioneOptions: ReactSelectOption[];
    }> => {
      const response = await apiClient.leadsControllerService.getLeadFields();

      const leadSourceOptions = response
        .find(item => item.name === 'LeadSource')
        ?.picklistValues.filter(item => item.active)
        .map(item => ({ value: item.value, label: item.label })) || [];

      const fonteAcquisizioneOptions = response
        .find(item => item.name === 'Fonte_di_acquisizione__c')
        ?.picklistValues.filter(item => item.active)
        .map(item => ({ value: item.value, label: item.label })) || [];

      return { leadSourceOptions, fonteAcquisizioneOptions };
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: false,
    refetchOnMount: false,
  });

  return (
    <LeadFormData
      initialValues={initialValues}
      submitFn={createLeadMutation}
      leadSourceOptions={fields?.leadSourceOptions || []}
      fonteAcquisizioneOptions={fields?.fonteAcquisizioneOptions || []}
      validationSchema={validationsLeadCreateForm}
    />
  );
}

export default LeadCreate;
